import React from "react";
import Shell from "@/components/Shell";
import { Card } from "@/components/ui/card";
import { HardHat, Wrench } from "@phosphor-icons/react";

/**
 * Alt Yüklenici / Taşeron Yönetim Modülü sayfaları için ortak iskelet.
 * İçerik ileriki fazlarda doldurulacak.
 */
export default function SubcontractorPlaceholder({ title, icon: Icon, description }) {
  const PageIcon = Icon || HardHat;
  return (
    <Shell title={title} subtitle="Alt Yüklenici Yönetimi">
      <Card className="p-16 rounded-none sm:rounded-sm border-slate-200 text-center">
        <PageIcon size={56} weight="duotone" className="mx-auto text-[#95C11F]" />
        <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-bold mt-4">
          Yakında
        </div>
        <div className="text-lg font-bold text-[#1B4776] mt-2">{title}</div>
        {description && (
          <p className="text-sm text-slate-600 mt-2 max-w-2xl mx-auto">{description}</p>
        )}
        <div className="mt-6 inline-flex items-center gap-2 text-[10px] uppercase tracking-widest font-bold text-amber-700 bg-amber-50 border border-amber-200 px-3 py-1.5">
          <Wrench size={12} weight="bold" />
          Bu modül geliştirme aşamasında — içerik yakında eklenecek
        </div>
      </Card>
    </Shell>
  );
}
